// @flow
/**
 * Shows a lesson
 */

import React from 'react';
import type {Node} from 'react';
import styles from './lesson.module.css';
import YouTube from 'react-youtube';

type LessonFieldsType = {
  field_headline: Array<{
    value: string,
  }>,
  field_body: Array<{
    value: string,
  }>,
  field_image: Array<{
    alt: string,
    url: string,
  }>,
  field_youtube_id: Array<{
    value: string,
  }>,
};

export const Lesson = ({
  field_headline,
  field_body,
  field_image,
  field_youtube_id,
}: LessonFieldsType): Node => (

  <div className={`${styles.lesson} lesson-component`}>
    <h3 className={`${styles.subHeader} fontBrown`}>{field_headline[0].value}</h3>
    {
      field_image.length > 0 && <img
        className={styles.img}
        src={field_image[0].url}
        alt={field_image[0].alt} />
    }
    {
      field_body.length > 0 && (
        <div className={`${styles.linkIcons} fontTisa`} dangerouslySetInnerHTML={{
                 __html: field_body[0].value,
             }} />
      )
    }
    {
      field_youtube_id.length > 0 && (
        <div className={styles.video}>
          <iframe className="youtubeVideo" type="text/html" width="100%" height="100%"
                  src={'https://www.youtube.com/embed/' + field_youtube_id[0].value +'?enablejsapi=1&version=3&playerapiid=ytplayer&rel=0'}
                  frameBorder="0" allowscriptaccess="always" />


        </div>
      )
    }


  </div>
);



// WEBPACK FOOTER //
// ./src/components/ModuleComponent/Lesson.js